import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  update({ detail: { ticketHint } }) {
    if (ticketHint) this.element.textContent = ticketHint;
  }
}
